import { get, getV5, post } from "@Lib/request";
import { path } from "./url";
import * as ts from "../types/kindsum";

const { usedCarApiV4, usedCarApiV3, newCarApiV2, newCarApiV3, newCarApiV4, newCarApiV1, newCarApiV5 } = path;

// 空间舒适性
export async function getComfort(params: any) {
  return await get(`${newCarApiV3}/superTest/comfort`, params);
}

// 空间舒适性检测
export async function postComfort(params: any) {
  return await post(`${newCarApiV3}/superTest/comfort`, params);
}

// 文章導航
export async function fetchArticleNav(params): Promise<ts.Response<ts.IArticleNav>> {
  return await get(`${newCarApiV4}/article/summary-nav`, params);
}

// 综述页详情
export async function fetchKindsPcInfo(params: { kindId: number }): Promise<ts.Response<ts.IKindsPcInfo>> {
  return await getV5(`${newCarApiV5}/kinds/pc/info`, params);
}

//
export async function fetchArticleList(params: ts.IArticleListParams): Promise<ts.Response<ts.IArticleList>> {
  return await get(`${newCarApiV5}/article/list`, params);
}

export async function fetchSuperTestCharts(params: any) {
  return await get(`${newCarApiV3}/superTest/kind/charts`, params);
}

export async function fetchSuperTestShock(params: any) {
  return await get(`${newCarApiV3}/superTest/shock`, params);
}

// 性能 - 英雄榜 - 排名
export async function fetchSuperTestRank(params: any) {
  return await get(`${newCarApiV3}/superTest/kind/rank`, params);
}

// 无实测 - 相关资讯
export async function fetchKindSumRecommend(params: any) {
  return await get(`${newCarApiV5}/article/pc/kind-summary-recommend`, params);
}

// 综述页详情
export async function fetchRecommendUsedCar(params: any) {
  return await get(`${usedCarApiV4}/items/newCar/recommends`, params);
}

// 安全数据获取
export async function fetchKindsSafeEquip(params: any) {
  return await get(`${newCarApiV5}/kinds/safe-equip`, params);
}

// 配备详解获取
export async function fetchSafeEquipIntro(params: any) {
  return await get(`${newCarApiV5}/kinds/safe-equip/intro`, params);
}

// 推薦車款比較
export async function fetchRecommendKindsCompare(params: any) {
  return await get(`${path.newCarApiV4}/recommend/compare/kind`, params);
}

// 車款介紹
export async function fetchKindsIntro(params: any) {
  return await get(`${path.newCarApiV5}/kinds/introduction-light`, params);
}